import { columnsStyles } from "@insite/content-library/Widgets/ProductList/ProductListColumns";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

columnsStyles.leftColumnGridItem = {
    css: css`
        border: ${getColor("common.border")} 1px solid;
        padding: 0;
        margin: 10px 10px 95px 0 !important;
        flex-basis: calc(25% - 10px);
        max-width: calc(25% - 10px);
        ${({ theme }: { theme: BaseTheme }) =>
        breakpointMediaQueries(
            theme,
            [
                null,
                css`
                    flex-basis: 100%;
                    max-width: 100%;
                    margin: 0 10px !important;
                `,
            ],
            "max",
        )}
    `,
};
